import { supabase } from "../lib/supabase";

export async function getCurrentUser() {
  const { data, error } = await supabase.auth.getUser();

  if (error) throw error;
  if (!data?.user) throw new Error("Not authenticated");

  return data.user;
}

export async function getUserWorkspaces() {
  const user = await getCurrentUser();

  const { data, error } = await supabase
    .from("workspace_members")
    .select(`
      role,
      workspace_id,
      workspaces (
        id,
        name,
        owner_id,
        created_at
      )
    `)
    .eq("user_id", user.id);

  if (error) throw error;

  return (data || []).map((row) => ({
    id: row.workspace_id,
    role: row.role,
    ...row.workspaces,
  }));
}

export async function getActiveWorkspace() {
  const workspaces = await getUserWorkspaces();

  if (!workspaces.length) {
    throw new Error("No workspace found for current user");
  }

  // Later: replace with saved user preference
  return workspaces[0];
}

export async function requireActiveWorkspaceId() {
  const workspace = await getActiveWorkspace();

  if (!workspace?.id) {
    throw new Error("Missing active workspace");
  }

  return workspace.id;
}